import { render } from "./institution.vue?vue&type=template&id=28fbbcb1&scoped=true"
import script from "./institution.vue?vue&type=script&lang=js"
export * from "./institution.vue?vue&type=script&lang=js"

import "./institution.vue?vue&type=style&index=0&id=28fbbcb1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fbbcb1"]])

export default __exports__